import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CardExpandable from "../../card/CardExpandable";
import DetailField from "../../card/DetailField";
import RoleField from "../../TableEntities/Fields/RoleField";

export default function UsersMobileView({ users, canEditUsers, onEdit }) {
  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      {users.map(row => (
        <Card key={row.id || row.email}>
          <CardContent sx={{ "&:last-child": { pb: 2 } }}>
            <Box mb={1.5}>
              <Typography color="text.secondary" fontWeight={500}>
                {row.name || row.email}
              </Typography>
              {row.email && (
                <Typography mt={0.5} color="primary" sx={{ wordBreak: "break-word" }}>
                  {row.email}
                </Typography>
              )}
            </Box>
            <CardExpandable
              actions={
                canEditUsers ? (
                  <IconButton aria-label="Edit" onClick={() => onEdit(row.id)} size="small">
                    <EditOutlinedIcon color="action" />
                  </IconButton>
                ) : null
              }
            >
              <Box display="flex" flexDirection="column" gap={1}>
                <DetailField label="Permission Role">
                  <RoleField value={row.role} />
                </DetailField>
              </Box>
            </CardExpandable>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

